module.exports = __webpack_public_path__ + "img/result_warn.af4261db.png";